<table mat-table [dataSource]="dataSource" class="table">
  <!-- id Column -->
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef class="index-column"></th>
    <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="lastName">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau users | header"
    >
      Nom
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.lastName }}
      <small>{{ element.firstName }}</small>
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="email">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau users | header"
    >
      Email
    </th>
    <td mat-cell *matCellDef="let element">{{ element.email }}</td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="role">
    <th mat-header-cell *matHeaderCellDef>Type</th>
    <td mat-cell *matCellDef="let element">
      <mat-icon>{{ element?.role?.id === 1 ? "star" : "face" }}</mat-icon>
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="compagnie">
    <th
      mat-header-cell
      *matHeaderCellDef
      i18n="component tableau users | header"
    >
      Nom de la société
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.compagnie?.name }}
    </td>
  </ng-container>

  <!-- Settings Column -->
  <ng-container matColumnDef="settings">
    <th mat-header-cell *matHeaderCellDef class="settings-column"></th>
    <td mat-cell *matCellDef="let element">
      <button
        mat-icon-button
        type="button"
        [matMenuTriggerFor]="menu"
        *appHasRole="['Admin', 'Operator']"
      >
        <mat-icon>settings</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @if (userMenuContainer.includes('update')) {
        <button
          mat-menu-item
          (click)="openUpdate(element)"
          i18n="component tableau users | bouton"
          *appHasRole="['Admin', 'Operator']"
        >
          Mettre à jour
        </button>
        } @if (userMenuContainer.includes('delete')) {
        <button
          mat-menu-item
          (click)="delete(element)"
          i18n="component tableau users | bouton"
          *appHasRole="['Admin', 'Operator']"
        >
          Supprimer
        </button>
        } @if (userMenuContainer.includes('link')) {
        <button
          mat-menu-item
          (click)="openCompagnieLink(element)"
          i18n="component tableau users | bouton"
          *appHasRole="['Admin', 'Operator']"
        >
          Lier à une société
        </button>
        }
      </mat-menu>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  <tr *matNoDataRow>
    <td colspan="5">
      <p
        class="justify-center no-data"
        i18n="component tableau user | row no data"
      >
        Aucun user trouvé
      </p>
    </td>
  </tr>
</table>
